export function timeAgo(date: any, now: Date = new Date()){
  let d = new Date(date.toString());
  const diffSeconds = Math.round((now.getTime() - d.getTime()) / 1000);
  const suffix = diffSeconds >= 0 ? 'ago' : 'from now';
  let seconds = Math.abs(diffSeconds);
  let minutes = Math.round(Math.abs(seconds / 60));
  let hours   = Math.round(Math.abs(minutes / 60));
  let days    = Math.round(Math.abs(hours / 24));
  let months  = Math.round(Math.abs(days/30.416));
  let years   = Math.round(Math.abs(days/365));
  if (Number.isNaN(seconds)){ return ''; }
  else if (seconds <= 45) { return 'a few seconds ' + suffix;      }
  else if (seconds <= 90) { return 'a minute ' + suffix;           }
  else if (minutes <= 45) { return minutes + ' minutes ' + suffix; }
  else if (minutes <= 90) { return 'an hour ' + suffix;            }
  else if (hours <= 22  ) { return hours + ' hours ' + suffix;     }
  else if (hours <= 36  ) { return 'a day ' + suffix;              }
  else if (days <= 25   ) { return days + ' days ' + suffix;       }
  else if (days <= 45   ) { return 'a month ' + suffix;            }
  else if (days <= 345  ) { return months + ' months ' + suffix;   }
  else if (days <= 545  ) { return 'a year ' + suffix;             }
  else /* (days > 545) */ { return years + ' years ' + suffix;     }
}
